var render, staticRenderFns
import script from "./ClickableTitleMixin.vue?vue&type=script&lang=js&"
export * from "./ClickableTitleMixin.vue?vue&type=script&lang=js&"
import style0 from "./ClickableTitleMixin.vue?vue&type=style&index=0&id=79adc617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79adc617",
  null
  
)

export default component.exports